import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";

export const SrDialog = ({ detail, onClose }) => (
  <Dialog open={!!detail} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="srdialog" data-testid="sr-detail-dialog">
      <div className="eyebrow">Evidence detail</div>
      <DialogTitle asChild><h2 data-testid="sr-detail-title">{detail?.title}</h2></DialogTitle>
      <DialogDescription className="sr-only">{detail?.title}</DialogDescription>
      <div data-testid="sr-detail-body">{detail?.body}</div>
    </DialogContent>
  </Dialog>
);
